import PropTypes from 'prop-types'
import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'
import InputRow from './InputRow'

const propTypes = {
  /**
   * Inputs in the group
   */
  inputs: PropTypes.arrayOf(PropTypes.string).isRequired,
  /**
   * Title (message id) of the group
   */
  groupTitle: PropTypes.string,
  /**
   * callback to decide if input should be displayed or not
   * If return true, input is displayed
   */
  displayInput: PropTypes.func,
  /**
   * Function to render input. Should return a react node. Params: input
   */
  renderInput: PropTypes.func.isRequired,
  /**
   * Optional renderer for content displayed next to the input label
   */
  renderLabelAction: PropTypes.func,
}

const defaultProps = {
  groupTitle: null,
  displayInput: () => true,
  renderLabelAction: () => null,
}

function InputGroup(props) {
  const { groupTitle, inputs, displayInput, renderInput, renderLabelAction } = props

  const displayGroup = inputs.some((input) => displayInput(input))

  if (!displayGroup) {
    return null
  }

  return (
    <>
      {groupTitle && (
        <Row>
          <Col md="12" className="text-bold mb-2">
            <FormattedMessage id={groupTitle} />
          </Col>
        </Row>
      )}
      {inputs.map((input) => (
        <InputRow
          key={input}
          input={input}
          displayInput={displayInput}
          renderInput={renderInput}
          renderLabelAction={renderLabelAction}
          labelBold={!groupTitle && inputs.length === 1} // for groups of only 1 item that would have the same name as the group
        />
      ))}
    </>
  )
}

InputGroup.propTypes = propTypes
InputGroup.defaultProps = defaultProps

export default InputGroup
